module.exports = __webpack_public_path__ + "static/img/sushi.161f5180.svg";